
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import HowItWorks from './components/HowItWorks';
import AdvertiserForm from './components/AdvertiserForm';
import ComplianceNote from './components/ComplianceNote';

export default function AdvertisersPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <HowItWorks />
      <AdvertiserForm />
      <ComplianceNote />
      <Footer />
    </div>
  );
}
